export const defaultRippleTheme = {
  circleFill: "transparent",
  fill: "--neutral-a16",
};

export type RippleTheme = typeof defaultRippleTheme;
